<script setup lang="ts">
import ComparisonView from '@/views/itineraries/updates/comparison/ComparisonView.vue'

definePage({
  meta: {
    layout: 'blank',
    action: 'read',
    subject: 'ItineraryUpdate',
  },
})

const route = useRoute()
const router = useRouter()

const courseVersionId = computed(() => (route.query.courseVersionId as string) || '')
const committeeId = computed(() => (route.query.committeeId as string) || '')
const courseName = computed(() => (route.query.courseName as string) || 'Curso')
const committeeName = computed(() => (route.query.committeeName as string) || 'Comitê')

function handleClose() {
  router.back()
}
</script>

<template>
  <ComparisonView
    :course-version-id="courseVersionId"
    :committee-id="committeeId"
    :course-name="courseName"
    :committee-name="committeeName"
    @close="handleClose"
  />
</template>
